<div class="body">
    <app-header [header]="pageTitle"></app-header>
    <div [ngClass]="isLandingPage ? 'landingstyle' : 'max-w-6xl mx-auto pb-10 my-10 main-content'">
        <router-outlet></router-outlet>
    </div>
    <app-footer class="footer"></app-footer>
</div>
